import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin } from 'lucide-react';
import { GlassPage } from '../components/chrome';
import { PageHero } from '../components/ui';

const Team = () => (
  <GlassPage>
    <PageHero
      title={<>Our<br/>Team</>}
      lead="Meet the founder building the future of assistive technology."
    />

    <section className="px-4 md:px-6 pb-12 md:pb-16">
      <div className="max-w-[1600px] mx-auto">
        <div className="glass p-5 sm:p-8 md:p-12">
          <div className="flex items-start justify-between gap-4">
            <div>
              <h2 className="text-3xl md:text-5xl font-bold tracking-tighter mb-2 md:mb-3 text-zinc-900">
                Alexei Kvorosten
              </h2>
              <p className="text-xs md:text-base uppercase tracking-widest text-zinc-500 font-bold mb-3 md:mb-4">
                Founder & CEO
              </p>
              <p className="text-sm text-zinc-600">
                <span className="font-bold">Location:</span> Boston, Massachusetts
              </p>
            </div>
            <a
              href="https://www.linkedin.com/in/alexei-kvorosten-62b460369/"
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 glass-pill text-zinc-700 hover:bg-zinc-900 hover:text-white transition-all shrink-0"
              aria-label="Alexei Kvorosten on LinkedIn (opens in a new tab)"
            >
              <Linkedin size={22} />
            </a>
          </div>

          <div className="mt-6 space-y-4 text-zinc-600 leading-relaxed">
            <p>
              Alexei founded Korsa with a vision to enhance human communication through cognitive technology.
              He leads the company to create smart glasses that help people communicate in their everyday life.
            </p>
            <p>
              Based in Boston, Massachusetts, Alexei is passionate about building technology that makes a meaningful
              impact on the world, focusing on accessibility and inclusivity in design.
            </p>
          </div>
        </div>

        <div className="glass-strong p-5 sm:p-8 md:p-12 mt-4 md:mt-8">
          <h3 className="text-2xl md:text-3xl font-bold tracking-tighter mb-3 md:mb-4 text-zinc-900">
            Join our team
          </h3>
          <p className="text-zinc-600 mb-6">
            Looking for talented individuals who share our passion for assistive technology.
            Explore open positions and help us shape the future.
          </p>
          <Link to="/careers" className="btn-dark w-full sm:w-auto">
            View open positions
          </Link>
        </div>
      </div>
    </section>
  </GlassPage>
);

export default Team;
